// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","279":"component---src-pages-index-jsx","895":"component---src-pages-bio-js"}[chunkId] || chunkId) + "-" + {"125":"d036b84366a4afadeffa","279":"281d270f4ea56f45e324","452":"d9c66a70854c5aa91515","895":"00da09db3ed322d89716","896":"b65ac9d4762242c0e8b9"}[chunkId] + ".js";
};